export const MILESTONE_PLANNER_ONBOARDED = "milestonePlanner.onboarded";
export const MILESTONE_PLANNER_PLAN_ONBOARDED =
  "milestonePlanner.plan.onboarded";
export const MILESTONE_PLANNER_VISITOR_ONBOARDED =
  "milestonePlanner.visitor.onboarded";
export const MILESTONE_PLANNER_VISITOR_PLAN_ONBOARDED =
  "milestonePlanner.plan.visitor.onboarded";
